import * as types from './mutation-types';

export default {
  [types.SET_TOGGLE_MODAL_PRODUCT](state) {
    state.modalProductIsOpen = !state.modalProductIsOpen;
  },
  [types.SET_TOGGLE_MODAL_PRICE_UPDATE](state) {
    state.modalPriceUpdateIsOpen = !state.modalPriceUpdateIsOpen;
  },
  [types.SET_TOGGLE_MODAL_IMPORT_XML](state) {
    state.modalImportXmlIsOpen = !state.modalImportXmlIsOpen;
  },
  [types.SET_TOGGLE_MODAL_MANIFESTED_XMLS](state) {
    state.modalManifestedXmlsIsOpen = !state.modalManifestedXmlsIsOpen;
  },
  [types.SET_TOGGLE_MODAL_CANCEL_PURCHASE](state) {
    state.modalCancelPurchaseIsOpen = !state.modalCancelPurchaseIsOpen;
  },
  [types.SET_MODAL_CANCEL_PURCHASE_IDS](state, payload) {
    state.modalCancelPurchaseIds = payload;
  },
  [types.SET_LOADING_TAB_PRODUCT](state, payload) {
    state.loadingTabProduct = payload;
  },
  [types.SET_LOADING_TAB_PURCHASE](state, payload) {
    state.loadingTabPurchase = payload;
  },
  [types.SET_TOGGLE_MODAL_CHANGE_CFOP](state) {
    state.modalChangeCFOP = !state.modalChangeCFOP;
  },
};
